module.exports = __webpack_public_path__ + "static/media/personGrow.1bd95538.svg";